/*
 * lunna-read-progress.js — writes one number and nothing else.
 *
 * The bar only appears on pages long enough for the question to exist. On a
 * policy page or a short collection the indicator would be permanently near
 * full, which is worse than absent: a control that never says anything trains
 * people to stop looking at it. The threshold is measured, not guessed — twice
 * the viewport is roughly where a visitor stops being able to feel how much is
 * left.
 *
 * Height is re-measured on resize and whenever the document grows, because a
 * page that starts short can become long: a cart drawer renders, an accordion
 * opens, a section loads its images. Reading scrollHeight once on load would
 * leave the bar hidden on a page that has since earned it, or scaled against a
 * length that no longer exists.
 */
(function () {
  'use strict';

  if (window.LunnaReadProgress) return;
  window.LunnaReadProgress = true;

  /* Below this the page is short enough to feel, and the bar has nothing to
     tell anyone. */
  var MIN_RATIO = 2;

  var bar = null;
  var queued = false;

  function measure() {
    if (!bar) return;

    var doc = document.documentElement;
    var height = Math.max(doc.scrollHeight, document.body ? document.body.scrollHeight : 0);
    var scrollable = height - window.innerHeight;

    if (height < window.innerHeight * MIN_RATIO || scrollable <= 0) {
      bar.setAttribute('hidden', '');
      return;
    }

    bar.removeAttribute('hidden');

    var progress = window.scrollY / scrollable;
    if (progress < 0) progress = 0;
    if (progress > 1) progress = 1;

    bar.style.setProperty('--lunna-read', progress);
  }

  function schedule() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () {
      queued = false;
      measure();
    });
  }

  function start() {
    bar = document.querySelector('.lunna-read-progress');
    if (!bar) return;

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });

    // The document's height is not settled at DOMContentLoaded — images and
    // deferred sections are still arriving — and it keeps changing afterwards.
    if ('ResizeObserver' in window && document.body) {
      new ResizeObserver(schedule).observe(document.body);
    } else {
      window.addEventListener('load', schedule);
    }

    measure();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
